import { Component } from '@angular/core';
import { ListLinks } from '../../../../../@core/constants/list-links';
import { Harbour } from '../../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
import { HarbourService } from '../../services/harbour.service';
import { HarbourEditWidgetComponent } from '../../widgets/harbour-edit-widget/harbour-edit-widget.component';

@Component({
  selector: 'app-harbour-drop-down',
  template: '',
  providers: [HarbourService],
  standalone: true
})
export class HarbourDropDownComponent extends GenericBaseModelDropDown<Harbour> {

  constructor(private service: HarbourService) {
    super(service, "Harbour");
    this.createNewPopupComponent = HarbourEditWidgetComponent;
    this.listUrl.set(ListLinks.HARBOUR);
  }

}
